'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoWrench = function IoWrench(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm33.6 9c1.1 1.1 1.5 2.4 1.4 3.4s-0.5 3.1-2.5 5.1-6 3.3-8.8 1.9c-0.4-0.3-1-0.4-1.7 0.2-0.7 0.7-15.7 16.8-15.7 16.8-1.4 1.5-3.8 1.4-5.2 0s-1.5-3.8 0-5.2c0 0 16.2-15.1 16.8-15.7s0.4-1.3 0.2-1.8c-1.5-3.6 0.2-6.9 1.9-8.7 1.7-1.9 4-2.4 5.1-2.5 1-0.1 2.4 0.4 3.4 1.4l-4.4 4.4 0.7 4.4 4.3 0.7z m-29 25.6c0.5-0.5 0.5-1.3 0-1.8s-1.2-0.5-1.7 0-0.5 1.3 0 1.8 1.2 0.5 1.7 0z' })
        )
    );
};

exports.default = IoWrench;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/wrench.js
// module id = 2531
// module chunks = 0